import React, { Component } from 'react';

class AICatPrivacyPolicy extends Component {

  render() {
    return (
      <div style={{ padding: '20px', color: 'white'}}>
        <h1>Privacy Policy</h1>
        <p>
        At AICat, we are committed to protecting your privacy and ensuring the security of your personal data. This Privacy Policy explains how we collect and use your data when you use our AICat app. 
        <h3>1. Information we collect</h3>
        Analytical Data: We collect analytical data from the AICat app in order to understand how you use our app and to improve its functionality. This information may include information about your device, location, and how you use the app.<br/>
        Crash Data: We also collect crash data to help us identify and fix any issues with the app. The crash data collected includes information about your device, how you were using the app, the crash logs, and anonymized user data.
        <h3>2. How we use your information</h3>
        The information we collect is used to improve the functionality and performance of our app. We may also use the information to troubleshoot and fix any issues with the app.
        <h3>3. Disclosure of Information</h3>
        We do not sell, trade or share your personal data with any third parties. The analytical and crash data collected is only shared with trusted partners who assist us in the development and maintenance of the app.
        <h3>4. Security of Information</h3>
        We take reasonable steps to ensure the security of data collected through our app. We use encryption, password protection, and other security measures to protect the data we collect.
        <h3>5. Changes to Privacy Policy</h3>
        We reserve the right to modify or update this privacy policy at any time. We will notify you of any changes by updating the date of the most recent update at the bottom of this policy.
        <h3>6. Contact Us</h3>
        If you have any questions, comments, or concerns about our privacy policy, please contact us at: <a href="mailto:iplay.coder@gmail.com">AICat Support</a><br/><br/>
        Last updated: March 29, 2023.
        </p>
      </div>
    );
  }
}

export default AICatPrivacyPolicy